"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unify = exports.OccursError = exports.UnificationError = void 0;
const type_1 = require("./types/type");
const substitution_1 = require("./substitution");
const builders_1 = require("./types/builders");
const util_1 = require("../util");
class UnificationError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.UnificationError = UnificationError;
class OccursError extends Error {
    constructor(message) {
        super(message);
    }
}
exports.OccursError = OccursError;
function unify(t1, t2) {
    if (t1.kind === type_1.TypeKind.Number && t2.kind === type_1.TypeKind.Number) {
        return substitution_1.EMPTY_SUBSTITUTION;
    }
    else if (t1.kind === type_1.TypeKind.Boolean && t2.kind === type_1.TypeKind.Boolean) {
        return substitution_1.EMPTY_SUBSTITUTION;
    }
    else if (t1.kind === type_1.TypeKind.BigInt && t2.kind === type_1.TypeKind.BigInt) {
        return substitution_1.EMPTY_SUBSTITUTION;
    }
    else if (t1.kind === type_1.TypeKind.Character && t2.kind === type_1.TypeKind.Character) {
        return substitution_1.EMPTY_SUBSTITUTION;
    }
    else if (t1.kind === type_1.TypeKind.Variable) {
        return bindToVar(t1.name, t2);
    }
    else if (t2.kind === type_1.TypeKind.Variable) {
        return bindToVar(t2.name, t1);
    }
    else if (t1.kind === type_1.TypeKind.Function && t2.kind === type_1.TypeKind.Function) {
        const s1 = unify(t1.input, t2.input);
        const s2 = unify(substitution_1.substituteInType(s1, t1.output), substitution_1.substituteInType(s1, t2.output));
        return substitution_1.composeSubstitutions(s1, s2);
    }
    else if (t1.kind === type_1.TypeKind.Polymorphic && t2.kind === type_1.TypeKind.Polymorphic
        && t1.constructor === t2.constructor) {
        return reduceUnify(t1.parameters, t2.parameters);
    }
    else {
        throw new UnificationError(`Type Error: Cannot unify types "${type_1.showType(t1)}" and "${type_1.showType(t2)}"`);
    }
}
exports.unify = unify;
function bindToVar(typeVarName, type) {
    if (type.kind === type_1.TypeKind.Variable && typeVarName === type.name) {
        return substitution_1.EMPTY_SUBSTITUTION;
    }
    else if (builders_1.freeTypeVars(type).has(typeVarName)) {
        throw new OccursError(`Type Error: Occurs check failed, "${typeVarName}" appears in "${type_1.showType(type)}"`);
    }
    else {
        return { [typeVarName]: type };
    }
}
function reduceUnify(types1, types2) {
    const zippedTypes = util_1.zip(types1, types2);
    return zippedTypes.reduce((acc, [type1, type2]) => substitution_1.composeSubstitutions(acc, unify(substitution_1.substituteInType(acc, type1), substitution_1.substituteInType(acc, type2))), substitution_1.EMPTY_SUBSTITUTION);
}
//# sourceMappingURL=unification.js.map